var map = {
	"./CopyLink.png": "QHJV",
	"./Facebook.png": "qEcv",
	"./Instagram.png": "62l+",
	"./Line.png": "PD4T",
	"./Messenger.png": "lyqK",
	"./Msn.png": "Y4Et",
	"./Picture.png": "V/S6",
	"./Twitter.png": "/3iL",
	"./WhatsApp.png": "rVTI",
	"./more.png": "prvz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i4C/";